<div [formGroup]="fg">
  <div class="action-setting">
    <div class="description">
      {{ 'commonActions.setAllUsersAccessPowerBiWorkspace.description' | labelsProvider }}
    </div>
    <div class="action-setting-title">
      {{ 'commonActions.setAllUsersAccessPowerBiWorkspace.title' | labelsProvider }}
    </div>
    <mat-radio-group formControlName="accessLevel">
      <mat-radio-button [value]="fabricAccessLevel.viewer">
        {{ 'commonActions.setAllUsersAccessPowerBiWorkspace.viewer' | labelsProvider }}
      </mat-radio-button>
      <div class="space">
        {{ 'commonActions.setAllUsersAccessPowerBiWorkspace.viewerDescription' | labelsProvider }}
      </div>
      <br />
      <mat-radio-button [value]="fabricAccessLevel.contributor">
        {{ 'commonActions.setAllUsersAccessPowerBiWorkspace.contributor' | labelsProvider }}
      </mat-radio-button>
      <div class="space">
        {{ 'commonActions.setAllUsersAccessPowerBiWorkspace.contributorDescription' | labelsProvider }}
      </div>
      <br />
      <mat-radio-button [value]="fabricAccessLevel.member">
        {{ 'commonActions.setAllUsersAccessPowerBiWorkspace.member' | labelsProvider }}
      </mat-radio-button>
      <div class="space">
        {{ 'commonActions.setAllUsersAccessPowerBiWorkspace.memberDescription' | labelsProvider }}
      </div>
      <br />
      <mat-radio-button [value]="fabricAccessLevel.admin">
        {{ 'commonActions.setAllUsersAccessPowerBiWorkspace.admin' | labelsProvider }}
      </mat-radio-button>
      <div class="space">
        {{ 'commonActions.setAllUsersAccessPowerBiWorkspace.adminDescription' | labelsProvider }}
      </div>
    </mat-radio-group>
  </div>
</div>
